<script lang="ts" setup>
import { checkEnvSite } from "~~/server/utils/getAlgoliaConfig"
import { WikiProps } from "~/components/Card/Wiki.props"

const { params } = useRoute()

const { filters, facetFilterString } = usePageInfo()

const firstLetter = useState<string>("listingWikiArticles", () => "")
firstLetter.value = facetFilterString.value ?? ""

const indexName: string = `TOP_WIKI_ARTICLES${checkEnvSite()}`

const client = useAlgoliaRef()
const stateMapping = useStateMapping()
const algoliaRouter = useCustomRouting()

const configuration = ref({
  indexName: indexName,
  insights: true,
  routing: {
    router: algoliaRouter.value.router,
    stateMapping: stateMapping(indexName)
  },
  searchClient: client
})

const page = computed(() =>
  params?.page ? parseInt(params.page as string) - 1 : 0
)

const transformWiki = (items: any): WikiProps[] =>
  items.map(
    (item: any): WikiProps => ({
      title: item?.title ?? "",
      path:
        item?.slug && item?.category?.slug
          ? `${customPaths.wikiRoot}/${item.category.slug}/${item.slug}`
          : "#",
      text: item?.shortDescription ?? ""
    })
  )

const widgets = computed(() => [
  useAisHits({
    // @ts-ignore
    transformItems: (items) => transformWiki(items)
  }),
  useAisConfigure({
    searchParameters: {
      hitsPerPage: 9,
      page: page.value,
      distinct: true,
      filters: filters.value,
      clickAnalytics: true,
      facetFilters: [`firstLetter:${facetFilterString.value}`]
    }
  })
])
</script>

<template>
  <div>
    <AisInstantSearch :widgets="widgets" :configuration="configuration">
      <AisHits>
        <template #default="{ items }">
          <slot name="wikis" :items="items" />
        </template>
      </AisHits>
      <slot name="content" />
    </AisInstantSearch>
  </div>
</template>
